var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer-2d-wrap"},[_c('div',{class:{
    'pointer-icon': true,  
    'pointer-icon-active': _vm.active,  
  },on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.pointer.avatar}})]),(_vm.active)?_c('div',{staticClass:"pointer-detail"},[_c('detail',{attrs:{"pointer":_vm.pointer}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }